var Canvas = require('class/Canvas');
var utils = require('utils');

var Image = function (url) {
  var instance = this;
  var element = this.element = document.createElement('img');
  this.loaded = true;
  element.src = url;
  this.handle(0,0);
  element.onload = function (e) {
    instance.loaded = true;
    instance.size([element.width, element.height]);
    instance.trigger('load',instance,[e]);
  }
}

Image.prototype = {
  handle: Canvas.prototype.handle,
  draw: Canvas.prototype.draw,
  size: Canvas.prototype.size
};

utils.eventer(Image.prototype);

module.exports = Image;